import {ref} from "vue";
import {useInterviewStore} from "@/stores/interview-store";
import {useRoute, useRouter} from "vue-router";

/**
 * Composable for interview audio recording and handling.
 */
const useInterviewAudio = () => {
    const interviewStore = useInterviewStore();
    const router = useRouter();
    const route = useRoute();

    const recordPlayerRef = ref();
    const audioStarted = ref(false);

    /**
     * Create a new interview instance.
     */
    const startInstance = async () => {
        await interviewStore.startInterviewInstance();
    };

    /**
     * Start an instance, and mark the audio as started.
     */
    const startAudio = async () => {
        await startInstance();

        audioStarted.value = true;
    };

    /**
     * Store the audio file in store, and navigate to the interview finished page.
     */
    const recordFinished = async (audio: Blob) => {
        interviewStore.audio = audio;
        audioStarted.value = false;

        await navigateToInterviewFinished();
    };

    /**
     * Store the audio file in store, and navigate to the interview finished page.
     */
    const handleImport = async (file: Blob) => {
        interviewStore.audio = file;

        await startInstance();
        await navigateToInterviewFinished();
    };

    /**
     * Navigate to the interview finished page, keeping the query parameters intact.
     */
    const navigateToInterviewFinished = () => {
        return router.replace({name: 'interview-instances.finished', query: {...route.query}});
    };

    return {
        recordPlayerRef,
        audioStarted,
        startAudio,
        recordFinished,
        handleImport
    };
};

export default useInterviewAudio;
